:host {
  display: block;
  max-width: 100%;
  padding: 64px 0 16px 16px;
  overflow: hidden;
}

gz-labeled-content {
  &::part(label) {
    color: var(--chart-300-icon-buttons);
    text-transform: uppercase;
  }

}

.content {
  height: calc(100% - 86px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: calc(var(--spacer) - 2px);
}
